module.exports = "https://static.wmbcdn.com/uniweb/images/e9cab97b429e96d05ecf0b6bebe46195.svg";